export default __webpack_public_path__ + "static/media/html.5aeb7784.jpg";